/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Tests/Utils/MockDataHelper" />
import { VssService } from "VSS/Platform/Context";
import { IServiceEndpointComponentState, ConversionStatus } from "DistributedTaskUI/ServiceEndpoints/Details/Stores/ServiceEndpointStore";
import { ServiceEndpointRequest, ServiceEndpointRequestResult } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export class MockDefaultContributionService extends VssService {
    getData<T>(id : string): any {
        return undefined;
    }

    getSharedData(id : string): any {
        return undefined;
    }

    getContributionChildren(targetContributionId: string, itemContributionType: string): any {
        return [];
    }

    getContributionsByType(type: string): any {
        return undefined;
    }
}

export class MockFeatureService extends VssService {
    isFeatureEnabled(id: string, defaultValue?: boolean): boolean {
        return true;
    }

    isFeatureFlagEnabled(id: string, defaultValue?: boolean): boolean {
        return defaultValue || false;
    }
}

export class MockIdentityService extends VssService {

}

export class MockPageService extends VssService {
    getData(): any {
        return undefined;
    }
}

export class MockHistoryService extends VssService {
    getState(): any {
        return {};
    }

    pushState(state: any): void {

    }
}

export class MockIdentityPickerHttpClient {

}

export class MockServiceEndpointRestClient {
    executeServiceEndpointRequest(serviceEndpointRequest: ServiceEndpointRequest, project: string, endpointId: string): Promise<ServiceEndpointRequestResult> {
        const result = { result: [] } as ServiceEndpointRequestResult;
        return Promise.resolve(result);
    }
}

export class MockTfsPageService extends VssService {
    getData() {
        return {
            project: {
                id: "testProject"
            }
        };
    }
}

export class MockPerformanceService extends VssService {
    public endScenario(featureArea: string, scenarioName: string, isPageInteractive: boolean) {
        return {};
    }
}

export class MockLocationService extends VssService {
    getAssetLocation(pageContext : any, asset : string) {
        return "asset location";
    }
}

export const serviceEndpointLoadedState: IServiceEndpointComponentState = {
    serviceEndpoint: {
        id: "1",
        administratorsGroup: null,
        authorization: {
            parameters: {},
            scheme: "token"
        },
        createdBy: {
            _links: null,
            descriptor: "",
            directoryAlias: "",
            displayName: "Creator",
            id: "creator_id",
            imageUrl: "",
            inactive: false,
            isAadIdentity: true,
            isContainer: false,
            isDeletedInOrigin: false,
            profileUrl: "",
            uniqueName: "UniqueCreatorName",
            url: ""
        },
        data: {},
        description: "test endpoint",
        groupScopeId: null,
        isReady: true,
        isDisabled: false,
        isShared: false,
        isOutdated: false,
        name: "TestServiceConnection",
        operationStatus: null,
        owner: null,
        readersGroup: null,
        type: "jenkins",
        url: "endpointUrl",
        serviceEndpointProjectReferences: null
    },
    serviceEndpointExecutionHistoryRecords: [],
    serviceEndpointType: {
        name: "github",
        displayName: "Github",
        authenticationSchemes: [],
        dataSources: [],
        dependencyData: null,
        description: "",
        endpointUrl: null,
        helpLink: null,
        helpMarkDown: "",
        iconUrl: "",
        inputDescriptors: null,
        trustedHosts: null,
        uiContributionId: null
    },
    serviceEndpointOwnerEmail: "creator@testDomain.com",
    serviceEndpointNotFound: false,
    eligibleSchemaUpgrade: {
        authorizationHeaders: [],
        authorizationUrl: "",
        clientCertificates: [],
        dataSourceBindings: [],
        displayName: "",
        inputDescriptors: [],
        properties: {},
        requiresOAuth2Configuration: false,
        scheme: ""
    },
    eligibleSchemaDowngrade: {
        authorizationHeaders: [],
        authorizationUrl: "",
        clientCertificates: [],
        dataSourceBindings: [],
        displayName: "",
        inputDescriptors: [],
        properties: {},
        requiresOAuth2Configuration: false,
        scheme: ""
    },
    conversionStatus: ConversionStatus.UNAVAILABLE,
    dataLoaded: true,
    errorMessage: "",
    editingEnabled: true,
    convertingToSecretEnabled: true,
    itemCopiedToClipboard: null,
    oidcFederationSubject: "",
    oidcFederationIssuer: "",
    monitorUpgradeProcess: false
};
